import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import styles from '../../styles/Ppulbatu/1ChooseMember.module.css';

function FrameSelectionPpulbatu() {
  const navigate = useNavigate();
  const [selectedFrame, setSelectedFrame] = useState(null);

  const frameOptions = [
    { id: 'yongmeong', name: 'YONGMEONG', frameImage: '/img/Ppulbatu/Yongmeong.png', overlays: ['YM1.png','YM2.png','YM3.png','YM4.png'] },
    { id: 'hwangchoon', name: 'HWANGCHOON', frameImage: '/img/Ppulbatu/Hwangchoon.png', overlays: ['HC1.png','HC2.png','HC3.png','HC4.png'] },
    { id: 'bamgeut', name: 'BAMGEUT', frameImage: '/img/Ppulbatu/Bamgeut.png', overlays: ['BG1.png','BG2.png','BG3.png','BG4.png'] },
    { id: 'dagonyang', name: 'DAGONYANG', frameImage: '/img/Ppulbatu/Dagonyang.png', overlays: ['DG1.png','DG2.png','DG3.png','DG4.png'] },
    { id: 'hmmnyaring', name: 'HMMNYARING', frameImage: '/img/Ppulbatu/Hmmnyaring.png', overlays: ['HNR1.png','HNR2.png','HNR3.png','HNR4.png'] }
  ];

  const handleFrameSelect = (frame) => setSelectedFrame(frame);

  const handleContinue = () => {
    if (selectedFrame) {
      navigate('/photobooth/Ppulbatu', {
        state: {
          selectedFrame,
          frameImage: selectedFrame.frameImage,
          overlays: selectedFrame.overlays
        }
      });
    }
  };

  return (
    <div className={styles['frame-selection-container']}>
      <Link to="/" className={styles['frame-back-link']}>
        ← Back to Home
      </Link>

      <h2 className={styles['frame-selection-title']}>
        Please choose a frame
      </h2>

      <div className={styles['frame-selection-grid']}>
        {frameOptions.map((frame) => (
          <div key={frame.id} className={styles['frame-container']}>
            <div
              className={`${styles['frame-option']} ${selectedFrame?.id === frame.id ? styles['selected'] : ''}`}
              onClick={() => handleFrameSelect(frame)}
            >
              <div className={styles['frame-image-container']}>
                <img
                  src={frame.frameImage}
                  alt={frame.name}
                  className={styles['frame-image']}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className={styles['frame-fallback']} style={{ display: 'none' }}>
                  {frame.name}
                </div>
              </div>
            </div>
            <div className={styles['frame-name']}>{frame.name}</div>
          </div>
        ))}
      </div>

      <div className={styles['frame-continue-section']}>
        <button
          onClick={handleContinue}
          disabled={!selectedFrame}
          className={styles['frame-continue-button']}
        >
          Next &gt;
        </button>
      </div>
    </div>
  );
}

export default FrameSelectionPpulbatu;
